<template>
    <b-button-group class="btn-block">
        <b-button class="btn-step" squared @click="$router.back()" :aria-label="$t('footer.return')">
            <b-icon-arrow-left class="left" aria-hidden="true"/> {{$t('footer.return')}}
        </b-button>
        <b-button
            type="submit"
            class="btn-step m-0"
            squared
            @click="next">
            {{titleFooter}} <b-icon-arrow-right aria-hidden="true"/>
        </b-button>
    </b-button-group>
</template>

<script>
export default {
    name: 'CheckInFooter',
    props: {
        titleFooter: String,
    },
    data() {
        return {
            pushNext: 'termsandconditions'
        }
    },
    computed: {
        routes() {
            return this.$router.options.routes.find(r => r.name === 'contentGuest').children;
        },
        routeIndex() {
            return this.routes.findIndex(r => r.name === this.$route.name);
        },
        prev() {
            const route = this.routes[this.routeIndex - 1];
            return route && { name: route.name };
        },
    },
    methods:{
        next() {
            //const route = this.routes[this.routeIndex + 1];
            //this.$router.push({ name: route.name })
            //return route && { name: route.name };
        }
    }
}
</script>